import { render, staticRenderFns } from "./DocCreateForm.vue?vue&type=template&id=7f9e3a1e&"
import script from "./DocCreateForm.vue?vue&type=script&lang=js&"
export * from "./DocCreateForm.vue?vue&type=script&lang=js&"
import style0 from "./DocCreateForm.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports